module.exports = __webpack_public_path__ + "img/reloj.cb424765.gif";